import React, {useEffect, useRef} from 'react'
import Lottie from 'lottie-web'

const PlaneComponent = (props) => {

    const planeAnimationRef = useRef(null);

    useEffect (() =>{
        const planeAnimation = Lottie.loadAnimation({
            container: planeAnimationRef.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: require('../lottie/plane-loop-optimized.json'),
            rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
                }
        });

    },[]);


  return (

    <>
    <span className='planeContainer' ref={planeAnimationRef} alt={props.alt} title={props.title} > </span>
    </>


  )
}

export default PlaneComponent